module.exports = __webpack_public_path__ + "static/img/CO.a523a80a.jpg";